<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm2"></a></p>
<div class="fmhT sgc-1">
    ALSO BY DAVID RHODES
  </div>
<div class="ctag1 sgc-2">
    The Last Fair Deal Going Down<br/>
    Easter House<br/>
    Rock Island Line
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// davi_9781571318008_oeb_fm2_r1.vue?e8fc7b24